import {
    GET_API_KEYS_SUCCESS,
    GET_API_KEYS_FAILURE,

    CREATE_API_KEY_SUCCESS,
    CREATE_API_KEY_FAILURE,

    GET_API_KEY_SUCCESS,
    GET_API_KEY_FAILURE,

    UPDATE_API_KEY_SUCCESS,
    UPDATE_API_KEY_FAILURE,

    DELETE_API_KEY_SUCCESS,
    DELETE_API_KEY_FAILURE,

    CLEAR_API_KEY_SECRET,

    GET_API_KEY_PERMISSIONS_SUCCESS,
    GET_API_KEY_PERMISSIONS_FAILURE
} from "./actions";

const initialState = {
    getApiKeysResult: {
        success: true
    },
    apiKeyListResult: {
        Items: []
    },
    createApiKeyResult: {
        success: true
    },
    // Holds the plaintext key (apiKey field) until clearApiKeySecret() is dispatched.
    createdApiKey: null,

    getApiKeyResult: {
        success: true
    },
    apiKey: null,
    updateApiKeyResult: {
        success: true
    },
    deleteApiKeyResult: {
        success: true
    },
    getApiKeyPermissionResult: {
        success: true,
    },
    userApiKeyPermission: null,
};

const replaceInList = (apiKeyListResult, apiKey) => {
    let apiKeyIndex = apiKeyListResult.Items.findIndex(item => item.apiKeyId === apiKey.apiKeyId);
    if (apiKeyIndex > -1) {
        apiKeyListResult = { ...apiKeyListResult };
        apiKeyListResult.Items = [...apiKeyListResult.Items];
        apiKeyListResult.Items[apiKeyIndex] = apiKey;
    }
    return apiKeyListResult;
};

export default (state = initialState, action) => {
    let apiKeyListResult = {
        Items: []
    };
    let apiKey = null;
    switch (action.type) {
        case GET_API_KEYS_SUCCESS:
            return { ...state, getApiKeysResult: { success: true }, apiKeyListResult: action.payload.result };
        case GET_API_KEYS_FAILURE:
            return { ...state, getApiKeysResult: { success: false, ...action.payload.error }, apiKeyListResult: { Items: [] } };
        case CREATE_API_KEY_SUCCESS:
            return { ...state, createApiKeyResult: { success: true }, createdApiKey: action.payload.apiKey };
        case CREATE_API_KEY_FAILURE:
            return { ...state, createApiKeyResult: { success: false, ...action.payload.error }, createdApiKey: null };
        case GET_API_KEY_SUCCESS:
            return { ...state, getApiKeyResult: { success: true }, apiKey: action.payload.apiKey };
        case GET_API_KEY_FAILURE:
            return { ...state, getApiKeyResult: { success: false, ...action.payload.error }, apiKey: null };
        case UPDATE_API_KEY_SUCCESS:
            apiKeyListResult = state.apiKeyListResult;
            apiKey = state.apiKey;
            if (action.payload.apiKey) {
                apiKeyListResult = replaceInList(apiKeyListResult, action.payload.apiKey);
                if (apiKey && apiKey.apiKeyId === action.payload.apiKey.apiKeyId) {
                    apiKey = action.payload.apiKey;
                }
            }
            return { ...state, updateApiKeyResult: { success: true }, apiKeyListResult, apiKey };
        case UPDATE_API_KEY_FAILURE:
            return { ...state, updateApiKeyResult: { success: false, ...action.payload.error } };
        case DELETE_API_KEY_SUCCESS:
            apiKeyListResult = { ...state.apiKeyListResult };
            apiKeyListResult.Items = state.apiKeyListResult.Items.filter(item => item.apiKeyId !== action.payload.apiKeyId);
            return { ...state, deleteApiKeyResult: { success: true }, apiKeyListResult };
        case DELETE_API_KEY_FAILURE:
            return { ...state, deleteApiKeyResult: { success: false, ...action.payload.error } };
        case CLEAR_API_KEY_SECRET:
            return { ...state, createdApiKey: null };
        case GET_API_KEY_PERMISSIONS_SUCCESS:
            return { ...state, getApiKeyPermissionResult: { success: true }, userApiKeyPermission: action.payload.permission };
        case GET_API_KEY_PERMISSIONS_FAILURE:
            return { ...state, getApiKeyPermissionResult: { success: false, ...action.payload.error }, userApiKeyPermission: null };
        default:
            return state;
    }
};
